import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { WP_SITE_URL, WP_API } from '../constants/constants.js'
import ProgrammeStore from '../components/Programmes.js';

function SingleProgramme(){
	const { slug } = useParams(); // donne les paramètres de requête
	const WP_API_PAGE = 'programme'
	const [pageData, setPageData] = useState({}) //  déclare une variable d'état "pageData" qui est initialement définie comme un objet vide, "setPageData" est la fonction utilisée pour mettre à jour cette variable d'état.
	const [error, setError] = useState(false) // déclare une variable d'état "error" qui est initialement définie comme false, "setError" est la fonction utilisée pour mettre à jour cette variable d'état.
	


	async function fetchImageURL(podcast) {
		try {
			const response = await fetch(`${WP_SITE_URL}${WP_API}media/${podcast.acf.programme_visuel}`);
			const media = await response.json();
			const podcast_visuel_url = media.source_url;
			podcast.acf = { ...podcast.acf, podcast_visuel_url }
			return { ...podcast };
		} catch (error) {
			console.error(error);
			return podcast;
		}
	}

	/**
	 * Récupère les données d'une page spécifique à partir d'une API WordPress.
	 * Cette fonction est déclarée comme asynchrone (async) car elle effectue des opérations asynchrones,
	 * notamment l'appel à fetch pour récupérer les données de la page à partir de l'API WordPress.
	 * L'utilisation de async permet d'utiliser l'opérateur await pour attendre la résolution de la promesse renvoyée par fetch,
	 * assurant ainsi une exécution cohérente et asynchrone de la fonction.
	 *
	 * @param {number} id - L'identifiant de la page à récupérer.
	 * @returns {Promise} - Une promesse résolue avec les données de la page ou une erreur en cas d'échec.
	 */
	async function fetchPage(slug) {		
		try {		
			// Envoie une requête GET pour récupérer les données de la page spécifiée
			
			let response ;
			console.log(`fetch ${WP_SITE_URL}${WP_API}${WP_API_PAGE}?slug=${slug}`)			
			response = await fetch(`${WP_SITE_URL}${WP_API}${WP_API_PAGE}?slug=${slug}`)							
			const data = await response.json();		
			//const podcastsWithImageURLs = await Promise.all(data.map(fetchImageURL));
			setPageData(data[0])
			
		} catch (err) {
			// Affiche l'erreur dans la console et indique une erreur dans la variable d'état "error"
			console.log(err)			
			setError(true)
		}
	}

	useEffect(() => {
		// Effectue une action lorsqu'une dépendance (dans ce cas, 'id') change
		fetchPage(slug);
	}, [slug]);


	if (error) {
		// affiche en cas d'erreur 
		return <span>Oups il y a eu un problème</span>
	}else{
		if (Object.keys(pageData).length > 0) { // protege l'appel a Page si pageData est vide 
			return (
				<ProgrammeStore {...pageData} />
			);
		}
		
	}
}
export default SingleProgramme

